import type { ReactNode } from "react";
import { BondFormSectionHeader } from "./BondFormSectionHeader";
import { FormSection } from "./FormSection";
import { BondFormSelectInput, type BondFormSelectInputProps } from "./inputs/BondFormSelectInput";

export type BondFormSelectSectionProps = BondFormSelectInputProps & {
	header?: ReactNode;
	headerClassName?: string;
	contentClassName?: string;
	topPadding?: boolean;
	partial?: boolean;
	/** Id on the `FormSection` wrapper. The `id` prop lands on the input's own container. */
	sectionId?: string;
};

/**
 * `BondFormSelectInput` wrapped in the standard `FormSection`. Use in
 * controlled (non-RHF) hosts. RHF usages should use `fields/FormBondFormSelect`.
 */
export const BondFormSelectInputSection = ({
	header,
	headerClassName,
	contentClassName,
	topPadding = true,
	partial,
	sectionId = "bond-form-section",
	...inputProps
}: BondFormSelectSectionProps) => (
	<FormSection
		id={sectionId}
		header={
			header ?? (
				<BondFormSectionHeader
					tooltipId={`${sectionId}-tooltip`}
					showTooltip={!inputProps.value.templateId && inputProps.value.upload.files.length === 0}
				/>
			)
		}
		headerClassName={headerClassName}
		contentClassName={contentClassName}
		partial={partial}
		topPadding={topPadding ? true : undefined}
	>
		<BondFormSelectInput {...inputProps} />
	</FormSection>
);
